import get from 'lodash/get';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { AdditionalInfo } from 'src/modules/providers/components/AdditionalInfo';

type Props = RouteComponentProps<{}, {}, { nextScreen: string }>;

const ProvideAdditionalInfoPage: React.FC<Props> = ({ history, location }) => {
    const nextScreen = get(location, 'state.nextScreen') || '/';

    return <AdditionalInfo onSubmit={() => history.replace(nextScreen)} />;
};

export default ProvideAdditionalInfoPage;
